'use client'
import { useSessionReconciliation } from '@/hooks/useSessionReconciliation'

// Mounted once globally; the hook itself no-ops on non-protected routes. Renders nothing.
const SessionReconciler = () => {
  useSessionReconciliation()
  return null
}

export default SessionReconciler
